/**
 * Ferry passenger custom validations
 * Extracted from passengerConfig for readability and reuse
 */

/**
 * Returns custom validation rules for ferry passenger selection
 * @param {Object} FERRY_PASSENGER_TYPES - Slugs for passenger types
 * @returns {Array} List of validation rule objects
 */
export const createFerryPassengerCustomValidations = (
  FERRY_PASSENGER_TYPES,
) => [
  {
    rule: (values) => {
      const adults = values[FERRY_PASSENGER_TYPES.ADULT] || 0;
      return adults >= 1;
    },
    messageKey: "ferry.passengerValidationMinAdult",
    message: "En az bir yetişkin yolcu seçilmesi gerekmektedir",
    path: FERRY_PASSENGER_TYPES.ADULT,
  },
  {
    rule: (values) => {
      const children = values[FERRY_PASSENGER_TYPES.CHILD] || 0;
      if (children > 0) {
        const adults =
          (values[FERRY_PASSENGER_TYPES.ADULT] || 0) +
          (values[FERRY_PASSENGER_TYPES.YOUNG] || 0);
        return adults >= 1;
      }
      return true;
    },
    messageKey: "ferry.passengerValidationChildNeedsAdult",
    message: "Çocuk yolcular için en az bir yetişkin veya genç gereklidir",
    path: FERRY_PASSENGER_TYPES.CHILD,
  },
];
